function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { LastCircleBtn, NextCircleBtn } from "./components/CircleBtn/index";
import "./index.less";
var TabPlus = function TabPlus(_ref) {
  var _items$, _items, _items$key;
  var defaultActiveKey = _ref.defaultActiveKey,
    activeKey = _ref.activeKey,
    items = _ref.items,
    onChange = _ref.onChange,
    iconNormal = _ref.iconNormal,
    iconActive = _ref.iconActive,
    iconPosition = _ref.iconPosition,
    _ref$needMobileBtn = _ref.needMobileBtn,
    needMobileBtn = _ref$needMobileBtn === void 0 ? false : _ref$needMobileBtn,
    _ref$needPcBtn = _ref.needPcBtn,
    needPcBtn = _ref$needPcBtn === void 0 ? false : _ref$needPcBtn,
    handleLastFun = _ref.handleLastFun,
    handleNextFun = _ref.handleNextFun,
    _ref$mobileMoreTabs = _ref.mobileMoreTabs,
    mobileMoreTabs = _ref$mobileMoreTabs === void 0 ? false : _ref$mobileMoreTabs;
  var _useState = useState(defaultActiveKey !== null && defaultActiveKey !== void 0 ? defaultActiveKey : 0),
    _useState2 = _slicedToArray(_useState, 2),
    key = _useState2[0],
    setKey = _useState2[1];
  // mobile时需要展示的key
  useEffect(function () {
    setKey(defaultActiveKey);
  }, []);
  useEffect(function () {
    console.log('key', key);
    console.log('typeof', _typeof(key));
  }, [key]);
  useEffect(function () {
    setKey(activeKey !== null && activeKey !== void 0 ? activeKey : 0);
  }, [activeKey]);
  var handleTabClick = function handleTabClick(key) {
    console.log('2');
    console.log('key', key);
    setKey(key);
    if (onChange) {
      onChange(key);
    }
  };
  function getIcon(itemKey) {
    if (key === itemKey) {
      return iconActive;
    } else {
      return iconNormal;
    }
  }
  var lastFun = function lastFun(key, e) {
    e.stopPropagation();
    setKey(key * 1 - 1);
    if (handleLastFun) {
      handleLastFun(key);
    }
  };
  var nextFun = function nextFun(key, e) {
    e.stopPropagation();
    var nextKey = Number(key) + 1;
    setKey(nextKey);
    if (handleNextFun) {
      handleNextFun(key);
    }
  };
  // mobile只显示当前key最近的三个tab title
  var checkIsMobileShow = function checkIsMobileShow(currentKey) {
    var itemLength = (items === null || items === void 0 ? void 0 : items.length) - 1;
    if (key === 0) {
      if (currentKey * 1 === key * 1 || currentKey * 1 === key * 1 + 1 || currentKey * 1 === key * 1 + 2) return true;
    } else if (key === itemLength) {
      if (currentKey * 1 === key * 1 || currentKey * 1 === itemLength - 1 || currentKey * 1 === itemLength - 2) return true;
    } else if (key * 1 > 0 && key * 1 < itemLength) {
      if (currentKey === key * 1 + 1 || currentKey * 1 === key * 1 || currentKey === key * 1 - 1) return true;
    }
    return false;
  };

  /**
   *
   * @param item 当前项
   * @param icon 当前tab对应icon
   * @returns 渲染带icon的当前项
   */
  var renderItem = function renderItem(item, icon) {
    return /*#__PURE__*/React.createElement("div", {
      className: "iron-tab-item-inner"
    }, iconPosition === 'left' && /*#__PURE__*/React.createElement("div", {
      className: "iron-label-tab"
    }, /*#__PURE__*/React.createElement("div", {
      className: "iron-icon-tab-l"
    }, icon), item.label), iconPosition === 'right' && /*#__PURE__*/React.createElement("div", {
      className: "iron-labelTab"
    }, item.label, " ", /*#__PURE__*/React.createElement("div", {
      className: "iron-icon-tab-r"
    }, icon)));
  };

  /**
   * @param item 当前item
   * @returns 当前item该渲染的icon
   */
  function getEachItemIcon(item) {
    if (key === item.key) {
      return item.activeIcon;
    } else {
      return item.normalIcon;
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-tabs-plus-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-flex gap-6"
  }, needPcBtn && items && (items === null || items === void 0 ? void 0 : items.length) !== 1 && /*#__PURE__*/React.createElement(LastCircleBtn, {
    disabled: key === ((_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.key),
    onClick: function onClick(e) {
      return lastFun(key, e);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "iron-tab-nav"
  }, items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.key || idx,
      className: "iron-tab-item-outer ".concat(key === item.key ? 'active' : '', " ").concat(mobileMoreTabs ? checkIsMobileShow(item.key) ? 'iron-tab-mobile-show' : '' : ''),
      onClick: function onClick() {
        return handleTabClick(item.key);
      }
    }, needMobileBtn && idx !== 0 && /*#__PURE__*/React.createElement(LastCircleBtn, {
      onClick: function onClick(e) {
        return lastFun(item.key, e);
      }
    }), iconNormal ? renderItem(item, getIcon(item.key)) : item.normalIcon ? renderItem(item, getEachItemIcon(item)) : /*#__PURE__*/React.createElement("div", {
      className: "iron-tab-item-inner"
    }, item.label), needMobileBtn && idx !== (items === null || items === void 0 ? void 0 : items.length) - 1 && /*#__PURE__*/React.createElement(NextCircleBtn, {
      onClick: function onClick(e) {
        return nextFun(item.key, e);
      }
    }));
  })), needPcBtn && items && (items === null || items === void 0 ? void 0 : items.length) !== 1 && /*#__PURE__*/React.createElement(NextCircleBtn, {
    disabled: key === ((_items = items[(items === null || items === void 0 ? void 0 : items.length) - 1]) === null || _items === void 0 ? void 0 : _items.key),
    onClick: function onClick(e) {
      return nextFun(key, e);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "iron-tab-content iron-flex-grow1"
  }, /*#__PURE__*/React.createElement("div", null, items[key] && ((_items$key = items[key]) === null || _items$key === void 0 ? void 0 : _items$key.children))));
};
TabPlus.defaultProps = {
  activeKey: 0,
  defaultActiveKey: 0,
  onChange: null,
  items: [],
  iconNormal: false,
  iconActive: false,
  iconPosition: 'left'
};
TabPlus.defaultProps.defaultActiveKey = TabPlus.defaultProps.activeKey;
export default TabPlus;